import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/styles/app.scss';
import 'assets/styles/form.scss';
import 'assets/styles/theme.scss';
import 'assets/styles/customTheme.scss';
import 'assets/styles/modal.scss';
import loadable from '@loadable/component';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from 'components/authentication/LoginPage';
import { useSelector } from 'react-redux';
import PrivateRoute from 'components/routes/PrivateRoute';
import Page404 from 'components/pages/Page404';
import TestSuccessPage from 'components/external-user/conduct-test/TestSuccessPage';
import TestErrorPage from 'components/external-user/conduct-test/TestErrorPage';
import Login from 'components/authentication/Login';
import Test from 'components/pages/Test';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import KosoftRegForm from 'components/pages/KosoftRegForm';
import NewUpdateExam from 'components/exam/modal/NewUpdateExam';
import ConductExam from 'components/external-user/ConductExam';

const RegistrationForm = loadable(() => import('components/pages/RegistrationForm'), { fallback: <LoadingIndicator /> });
const ParticipateExam = loadable(() => import('components/external-user/ParticipateExam'), { fallback: <LoadingIndicator /> });
const GuestLogin = loadable(() => import('components/external-user/GuestLogin'), { fallback: <LoadingIndicator /> });
const GuestInfo = loadable(() => import('components/external-user/GuestInfo'), { fallback: <LoadingIndicator /> });
const ForgotPassword = loadable(() => import('components/authentication/ForgotPassword'), { fallback: <LoadingIndicator /> });
const ResetPassword = loadable(() => import('components/authentication/ResetPassword'), { fallback: <LoadingIndicator /> });

const App: React.FC = () => {
    const { userInfo } = useSelector((state: any) => state.auth);
    const isAuth = localStorage?.getItem('token');

    return (
        <div className="App">
            <Routes>
    {/* ✅ All public routes FIRST */}
    <Route path="/login" element={<LoginPage />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/guest-login/:id" element={<GuestLogin />} />
    <Route path="/guest-details" element={<GuestInfo />} />
    <Route path="/page-not-found" element={<Page404 />} />
    <Route path="/change-password/:id" element={<ResetPassword />} />
    <Route path="/test-page" element={<ConductExam />} />
    <Route path="/test-exam" element={<ParticipateExam />} />
    <Route path="/test-success" element={<TestSuccessPage />} />
    <Route path="/test-error" element={<TestErrorPage />} />
    <Route path="/candidate-registration-form" element={<KosoftRegForm />} />
    <Route path="/registration-form/:id" element={<RegistrationForm />} /> {/* ✅ public */}
    <Route path="/login-page" element={<Login />} />
    <Route path="/" element={<Navigate replace to="/login" />} />

    {/* ✅ Private routes LAST */}
    <Route path="/*" element={<PrivateRoute />} />
    <Route path="*" element={<Page404 />} />
</Routes>
        </div>
    );
};

export default App;
